import { BeanFormulario } from './BeanFormulario'
import { BeanJustificativa } from './BeanJustificativa'
import { BeanMonitoryCommentReply } from './BeanMonitoryCommentReply'
import { BeanMonitoryParameter } from './BeanMonitoryParameter'
import { BeanMonitoryQuestionAnswer } from './BeanMonitoryQuestionAnswer'
import { BeanOperacao } from './BeanOperacao'
import { BeanPerfil } from './BeanPerfil'
import { BeanRecording } from './BeanRecording'
import { BeanRegularAppraiser } from './BeanRegularAppraiser'
import { BeanStatusMonitory } from './BeanStatusMonitory'
import { BeanUsuario } from './BeanUsuario'


export class BeanMonitoria{
  constructor(
    public moniIdCdMonitoria  : string,
    public operIdCdOperacao  : string,
    public usuaIdCdUsuarioMonitor	 : number,
    public usuaIdUsuarioOperador : number,

    public usuaIdUsuarioGestor : string,
    public formIdCdFormulario	 : string,
    public perfIdCdPerfil	 : string,
    public moniNrTotalPontos	 : string,
    public moniDhInativo	 : string,
    public  moniDhRegistro	 : string,
    public  moniTxAvaliador: string,
    public  moniTxFeedback: string,
    public  moniTxAvaliado: string,
    public  moniTxAlteracao: string,
    public  justIdCdJustificativa: string,
    public  moniTxJustificativa: string,
    public moniDhFeedbackAvaliado: string,
    public usuaIdCdUsuarioFeedback: string,
    public moniDsTempooperacional: string,

    public  moniTxObservacao: string,
    public  moniDsData: string,
    public  moniNrHora: string,
   



    public userMonitor	 : BeanUsuario,
    public userOperador	 : BeanUsuario,
    public userFeedback : BeanUsuario,
    public userGestor			 : BeanUsuario,
    public profile	 : BeanPerfil,
    public operations	 : BeanOperacao,
    public monitorUsers	 : BeanUsuario,
    public forms	 : BeanFormulario,
    public monitoryQuestionAnswers: BeanMonitoryQuestionAnswer[],
    public monitoryParameter: BeanMonitoryParameter[],
    public statDsStatus: string,
    public recording: BeanRecording[],
    public statusMonitory: BeanStatusMonitory[],
    public justification: BeanJustificativa,
    public comment: BeanMonitoryCommentReply[],
    public lstRegularAppraiser : BeanRegularAppraiser[],

    public moniNrPontomedia: string,
    public  moniNrPontoextra: string

  ){}
}
